import { useEffect, useState } from "react";
import { useForm } from "../../utility/useForm";
import { PadvishRequestForm } from "../../utility/validationRules";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { useNavigate } from "react-router-dom";
import { ValidationErrorSpan } from "../../styles/global";
import { getLabList, insertPadvishRequestList } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import {InfoContainer, InfoText, InfoTextRed, StyledContainer } from "./styles";
import FormContainer from "../../components/FormContainer/FormContainer";
import { Col, Row } from "antd";
import CustomSelect from "../../components/_common/CustomSelect";
import { UpdateLabList } from "../../redux/reducers/lablistSlice";
import Input from "../../components/_common/Input";

const NewPadvishRequest = () => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(PadvishRequestForm) as any
    const [isLoading,setIsLoading] = useState(false);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
        if (myStore.labList.list && myStore.temperatureList.list) setIsLoading(false);
        if (!myStore.labList.list) loadLabs(); 
        if (myStore.auth.loginType === "labuser" ) {
            setValues((values:any) => ({
                ...values,
                ["lab"]: myStore.auth.userId,
              }));
        }


    },[])

    const loadLabs = () => {

        getLabList()
        .then((result:any) => {
            console.log(result.data.data);
            dispatch(UpdateLabList({labList:result.data.data}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }
    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    const FormSubmit = (e:any) => {
        e.preventDefault();
        
        let error= PadvishRequestForm(values);
        if (Object.keys(error).length == 0)
        {
            setIsSubmiting(true)

            insertPadvishRequestList(Number(values.lab),values.mobile,values.userCount? values.userCount:0)
            .then((result:any) => {
                console.log(result);
                setIsSubmiting(false)
                navigate("/" + myStore.auth.loginType + "/padvishRequest");
                sucessNotify("ثبت با موفقیت انجام شد")
            })
            .catch((error) => {
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage,undefined,5000)
            })

        }
        else
        {
          setErrors(error);
        }
        
    }

    return(
        <StyledContainer>

           <FormContainer title="درخواست ویروس کنترل پادویش" onSubmit={FormSubmit} isLoading={isLoading} isSubmiting={isSubmiting}  > 
                    <Row>
                        <Col lg={8} md={8} sm={12} xs={24}>
                            <CustomSelect
                                name="lab"
                                placeholder="آزمایشگاه"
                                itemList={myStore.labList.list}
                                value={values.lab || ""}
                                onChange={handleChange}
                                valueObjectField={"prk_AndriodLab_AutoID"}
                                displayObjectField={"str_LabPersianName"}
                                disabled = {myStore.auth.loginType === "labuser" ? true : false}
                            />
                            <ValidationType type="lab" />
                        </Col>

                        <Col lg={8} md={8} sm={12} xs={24}>
                            <Input
                                type="text"
                                name="mobile"
                                placeholder="موبایل"
                                value={values.mobile || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="mobile" />
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={24}>
                            <Input
                                type="text"
                                name="userCount"
                                placeholder="تعداد کاربر"
                                value={values.userCount || ""}
                                onChange={handleChange}
                            />
                            {/* <ValidationType type="mobile" /> */}
                        </Col>

                    </Row>
                 
           </FormContainer>

        </StyledContainer>
    )
}

export default NewPadvishRequest;